<app-page-header
  title="Meine Coin-Transaktionen"
  subtitle="Alle deine Coin-Transaktionen im Überblick"
  icon="account_balance_wallet"
  variant="gradient"
  [showBackButton]="true">
</app-page-header>

<div class="nlc-container">
    <div class="export-btn">
        <button class="nlc-button nlc-button-primary nlc-button-small" (click)="exportToCSV()">
            <mat-icon>download</mat-icon>
            Exportieren als CSV
        </button>
    </div>
    <div class="filter-section apple-card">
        <mat-form-field appearance="outline" class="year-filter">
            <mat-label>Jahr filtern</mat-label>
            <mat-select [value]="(selectedYear$ | async)" (selectionChange)="onYearChange($event.value)">
                <mat-option [value]="null">Alle Jahre</mat-option>
                <mat-option *ngFor="let year of availableYears$ | async" [value]="year">
                    {{ year }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-checkbox 
            [checked]="(hideGeneratedCoins$ | async)" 
            (change)="onHideGeneratedChange($event.checked)"
            class="generated-filter">
            Automatisch generierte Coins ausblenden
        </mat-checkbox>
    </div>
    <div class="nlc-transaction-history-table-card nlc-card">
        <table class="nlc-transaction-history-table">
            <thead>
                <tr class="nlc-table-header-row">
                    <th class="global-table-header-cell">Datum</th>
                    <th class="global-table-header-cell">Grund</th>
                    <th class="global-table-header-cell">Verwendet von</th>
                    <th class="global-table-header-cell">Auftragsnummer</th>
                    <th class="global-table-header-cell">Betrag</th>
                    <th class="global-table-header-cell">Vergeben von</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let tx of filteredTransactions$ | async" class="nlc-table-row">
                    <td class="global-table-cell">{{ tx.createdDate | date:'dd.MM.yyyy' }}</td>
                    <td class="global-table-cell">{{ tx.reason?.reasonText }}</td>
                    <td class="global-table-cell">
                        {{ tx.reason?.reasonText?.includes('Coins verwendet') ?
                        (tx.customer?.userDetails?.firstName || '') + ' ' + (tx.customer?.userDetails?.lastName || '')
                        : '-' }}
                    </td>
                    <td class="global-table-cell">{{ tx.reflexOrderNo || '-' }}</td>
                    <td class="global-table-cell">
                        <span [class.positive-amount]="(tx.amount || 0) > 0"
                            [class.negative-amount]="(tx.amount || 0) < 0">
                            {{ tx.amount }}
                        </span>
                    </td>
                    <td class="global-table-cell">
                        {{ tx.reason?.reasonText?.includes('Generiert') ? 'Niclen GmbH' : (tx.grantedBy ?
                        (tx.grantedBy.firstName + ' ' + tx.grantedBy.lastName) : '-') }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="(filteredTransactions$ | async)?.length === 0" class="empty-state">
            <mat-icon>info</mat-icon>
            <p>Keine Transaktionen für das ausgewählte Jahr gefunden.</p>
        </div>
    </div>
</div>
